// extracted by mini-css-extract-plugin
module.exports = {"StockCommodityPage":"commodity-exposure_StockCommodityPage__9vavR"};